<div class="practica-alert d-flex flex-column" role="alert">
    <div class="close align-self-end" (click)="onClose()" *ngIf="close.observed">&times;</div>
    <ng-content></ng-content>
</div>
